// *************************** */
export function check_rule(id, rule, userFile) {
    userFile = userFile.toLowerCase()
    for(let i=0; i<rule.length; i++)
      rule[i].text = rule[i].text.toLowerCase()
       
    var txt = rule[1].text
    var txt2 = ''
    var txt3 = ''
    var txt4 = ''
    var t = 0
    var times = 0
    var pos1 = 0
    var pos2 = 0
    var pos3 = 0     
    var pos4 = 0     
    switch (id) {       
      case 1:   // 1. Text musí obsahovať $$$$ minimálne #### krát
            times = rule[3].text
            t = userFile.split(txt).length - 1
            if (t >= times) return true  
            else return false 
      case 2:   // 2. Text môže obsahovať $$$$ maximálne #### krát
            times = rule[3].text
            t = userFile.split(txt).length - 1
            if (t <= times) return true  
            else return false             
     case 3:   // 3. Text nesmie obsahovať $$$$
            if (userFile.indexOf(txt) > -1) return false  
            else return true 
     case 4:   // 4. Text $$$$ musí nasledovať za $$$$
            txt2 = rule[3].text
            if (userFile.indexOf(txt) > userFile.indexOf(txt2)) return true  
            else return false 
     case 5:   // 5. Text $$$$ musí byť pred $$$$
            txt2 = rule[3].text
            if (userFile.indexOf(txt) == -1  || userFile.indexOf(txt2) == -1) return false
            pos1 = userFile.indexOf(txt)
            pos2 = userFile.indexOf(txt2,pos1+1)
            if (pos1 < pos2) return true  
            else return false             
     case 6: // 6. Text $$$$ nesmie nasledovať za $$$$
            txt2 = rule[3].text
            if (userFile.indexOf(txt) > -1  && userFile.indexOf(txt2) > -1  && userFile.lastIndexOf(txt) < userFile.lastIndexOf(txt2)) return true  
            else return false 
     case 7: // 7. Text musí obsahovať dvojicu v tomto poradí: $$$$ a $$$$
            txt2 = rule[3].text
            if (userFile.indexOf(txt) == -1) return false
            while (userFile.indexOf(txt) > -1) {
              pos1 = userFile.indexOf(txt)
              pos2 = userFile.indexOf(txt2)
              pos3 = userFile.indexOf(txt,pos1+1)
              if (pos1 > pos2) return false // </p> <p> or <h1> without </h1>
              if (pos3 > -1 && pos3 < pos2) return false // <h1> <h1> </h1>
              userFile = userFile.substring(pos2+1)
            }
            if (userFile.indexOf(txt2) > -1) return false // </p>
            return true
     case 8: // 8. Text musí obsahovať trojicu v tomto poradí: $$$$ a $$$$ a $$$$
              txt2 = rule[3].text
              txt3 = rule[5].text
              pos1 = userFile.indexOf(txt)
              pos2 = userFile.indexOf(txt2,pos1+1)
              pos3 = userFile.indexOf(txt3,pos2+1)
              if (pos1 == -1 || pos2 == -1 || pos3 == -1) return false
              return true 
      case 9: // 9. Text musí obsahovať štvoricu v tomto poradí: $$$$ a $$$$ a $$$$ a $$$$
            txt2 = rule[3].text
            txt3 = rule[5].text
            txt4 = rule[7].text
            pos1 = userFile.indexOf(txt)
            pos2 = userFile.indexOf(txt2,pos1+1)
            pos3 = userFile.indexOf(txt3,pos2+1)
            pos4 = userFile.indexOf(txt4,pos3+1)
            if (pos1 == -1 || pos2 == -1 || pos3 == -1 || pos4 == -1) return false
            return true            
      case 10:  // 10. Text musí obsahovať #### krát text $$$$ medzi $$$$ a $$$$ 
                 times = rule[1].text 
                 txt2 = rule[3].text
                 txt3 = rule[5].text
                 txt4 = rule[7].text
                 pos1 = userFile.indexOf(txt3)
                 pos2 = userFile.indexOf(txt2,pos1+1)
                 pos3 = userFile.indexOf(txt4,pos2+1)

                 var tt = 0
                 while (pos3 > -1 && pos2> -1 && pos3 > -1) {
                    tt++
                    userFile = userFile.substring(pos3+1)
                    pos1 = userFile.indexOf(txt3)
                    pos2 = userFile.indexOf(txt2,pos1+1)
                    pos3 = userFile.indexOf(txt4,pos2+1)
                 }
                 if (tt == times) return true 
                 return false  
      case 11:  // 11. V poradí #### výskyt príkazu $$$$ musí mať nastavený parameter $$$$ na túto hodnotu: $$$$ // pred ; alebo >
                times = rule[1].text 
                txt2 = rule[3].text
                txt3 = rule[5].text
                txt4 = rule[7].text
                for(let i = 1; i < times; i++) {
                   pos1 = userFile.indexOf(txt2)
                   if (pos1 < 0) return false
                   userFile = userFile.substring(pos1+1)
                }
                pos1 = userFile.indexOf(txt2)
                if (pos1 < 0) return false
                var type = userFile.substring(pos1,pos1+1)
                if (type == '<') {
                     userFile = userFile.substring(pos1+1)
                     pos2 = userFile.indexOf('>')
                } else {
                     userFile = userFile.substring(pos1)  
                     pos2 = userFile.indexOf('}')
                }
                if (pos2 == -1) return false
                userFile = userFile.substring(0, pos2)
                pos3 = userFile.indexOf(txt3)
                if (pos3 > -1) pos4 = userFile.indexOf(txt4, pos3)
                // eslint-disable-next-line
                // console.log(pos2 + "," + pos3 + "," +pos4)
                if (pos3 == -1 || pos4 == -1) return false
                if (pos3 > pos4) return false
                return true
      case 12:  // 12. Ľubovoľný výskyt príkazu $$$$ musí mať nastavený parameter $$$$ na túto hodnotu $$$$
                txt2 = rule[3].text
                txt3 = rule[5].text
                while (userFile.indexOf(txt) > -1) {
                     pos1 = userFile.indexOf(txt)
                     // search end of command
                     type = userFile.substring(pos1,pos1+1)                     
                     if (type == '<') {
                            userFile = userFile.substring(pos1+1)
                            pos2 = userFile.indexOf('>')
                     } else {
                            userFile = userFile.substring(pos1)
                            pos2 = userFile.indexOf('}')
                     }
                       
                     // search parameter 
                     pos3 = userFile.indexOf(txt2)
                     // search value
                     pos4 = userFile.indexOf(txt3, pos3+1)
                     if (pos3 == -1 || pos4 == -1) return false
                     return true
                }
                return false

              }
    return false
}